"use strict";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.VisitorCodeManager = void 0;
var _tsRes = require("ts-res"),
  _storage = require("../storage"),
  _kameleoonError = require("../kameleoonError"),
  _constants = require("./constants"),
  _logging = require("../logging");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var VisitorCodeManager = /*#__PURE__*/function () {
  function VisitorCodeManager() {
    _classCallCheck(this, VisitorCodeManager);
    _defineProperty(this, "variationConfiguration", void 0), _defineProperty(this, "isConsentRequired", !1), _defineProperty(this, "setDataCallback", void 0), _defineProperty(this, "getDataCallback", void 0);
  }
  return _createClass(VisitorCodeManager, [{
    key: "consentRequired",
    get: function get() {
      return this.isConsentRequired;
    },
    set: function set(a) {
      this.isConsentRequired = a;
    }
  }, {
    key: "getData",
    set: function set(a) {
      this.getDataCallback = a;
    }
  }, {
    key: "setData",
    get: function get() {
      if (this.setDataCallback) return this.setDataCallback;
      throw new Error("Missing setDataCallback!");
    },
    set: function set(a) {
      this.setDataCallback = a;
    }
  }, {
    key: "validateVisitorCode",
    value: function validateVisitorCode(a) {
      return 0 === a.length ? (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.VisitorCodeEmpty)) : a.length > _constants.VISITOR_CODE_MAX_LENGTH ? (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.VisitorCodeMaxLength)) : (0, _tsRes.Ok)();
    }
  }, {
    key: "getVisitorCode",
    value: function getVisitorCode(a) {
      if (_logging.KameleoonLogger.debug(_templateObject || (_templateObject = _taggedTemplateLiteral(["CALL: VisitorCodeManager.getVisitorCode(defaultVisitorCode: ", ")"])), a), !this.getDataCallback || !this.setDataCallback) throw new Error("Missing getDataCallback or setDataCallback methods in getVisitorCode!");
      var b;
      var c = this.getDataCallback(_storage.KameleoonStorageKey.VisitorCode);
      return c && (b = c), b || (a ? (this.validateVisitorCode(a)["throw"](), b = a, _logging.KameleoonLogger.debug(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["Used default visitor code: ", ""])), b)) : (b = this.generateVisitorCode(), _logging.KameleoonLogger.debug(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["Generated new visitor code: ", ""])), b))), this.processSimulatedVariations(b), this.isConsentRequired || this.setDataCallback({
        visitorCode: b,
        key: _storage.KameleoonStorageKey.VisitorCode,
        maxAge: _constants.DEFAULT_MAX_AGE,
        path: _constants.PATH
      }), _logging.KameleoonLogger.debug(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["RETURN: VisitorCodeManager.getVisitorCode(defaultVisitorCode: ", ") -> (visitorCode: ", ")"])), a, b), b;
    }
  }, {
    key: "processSimulatedVariations",
    value: function processSimulatedVariations(a) {
      if (this.variationConfiguration) {
        var b = this.getSimulatedVariations(a);
        try {
          this.variationConfiguration.clearSimulatedVariations(a)["throw"](), null !== b && 0 < b.length && this.variationConfiguration.updateForcedFeatureVariations(a, b)["throw"]();
        } catch (a) {
          a instanceof Error && _logging.KameleoonLogger.error(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["Failed to process simulated variations: ", ""])), a.message);
        }
      }
    }
  }, {
    key: "getSimulatedVariations",
    value: function getSimulatedVariations(a) {
      var _this = this;
      _logging.KameleoonLogger.debug(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["CALL: VisitorCodeManager.getSimulatedVariations(visitorCode: ", ")"])), a);
      var b = this.getDataCallback(_storage.KameleoonStorageKey.KameleoonSimulationFFData);
      var c = null;
      if ("string" == typeof b && 0 < b.length) try {
        var _a = JSON.parse(decodeURIComponent(b));
        _a && "object" == _typeof(_a) && (c = Object.entries(_a).map(function (a) {
          var _a2 = _slicedToArray(a, 2),
            b = _a2[0],
            c = _a2[1];
          return _this.variationConfiguration.simulatedVariationFromJson(b, c);
        }).filter(function (a) {
          return null !== a;
        }));
      } catch (a) {
        a instanceof Error && _logging.KameleoonLogger.error(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["Failed to parse simulated variations: ", ""])), a.message);
      }
      return _logging.KameleoonLogger.debug(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["RETURN: VisitorCodeManager.getSimulatedVariations(visitorCode: ", ") -> (variations: ", ")"])), a, c), c;
    }
  }, {
    key: "generateVisitorCode",
    value: function generateVisitorCode() {
      var a = "abcdefghijklmnopqrstuvwxyz0123456789",
        b = [];
      for (var c = 0; c < _constants.VISITOR_CODE_LENGTH; c++) b.push(a[Math.floor(Math.random() * a.length)]);
      return b.join("");
    }
  }, {
    key: "setVariationConfiguration",
    value: function setVariationConfiguration(a) {
      this.variationConfiguration || (this.variationConfiguration = a);
    }
  }]);
}();
exports.VisitorCodeManager = VisitorCodeManager;